
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/arrivals",
      function () {
        return require("private-next-pages/arrivals.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/arrivals"])
      });
    }
  